import type { Paginated, PaginationQuery } from "@/configs/request";
import type { AdminActivity, AdminUser, AdminUserFilter, BlockReason, UserSession } from "@/types";

import { BaseApi } from "./base.api";

class AdminUsersApi extends BaseApi {
  private readonly baseUrl = "/admin/users";

  list(filter: AdminUserFilter = {}) {
    return this.request<Paginated<AdminUser>>(this.baseUrl, { query: { ...filter } });
  }

  getById(id: string) {
    return this.request<AdminUser>(`${this.baseUrl}/${id}`);
  }

  /**
   * Bloklash sababi MAJBURIY — backendda ham CHECK cheklovi bor
   * (users entity). Sababsiz blok bir oy o'tib "nega bloklangan?"
   * degan javobsiz savolga aylanadi.
   */
  block(id: string, reason: BlockReason, days?: number) {
    return this.request<AdminUser>(`${this.baseUrl}/${id}/block`, {
      method: "POST",
      // `days` berilmasa maydon UMUMAN yuborilmaydi — backend uni
      // "abadiy" deb o'qiydi. `null` yuborish validatsiyadan
      // o'tmasdi (`@IsInt()`), va `0` esa chegaradan tushardi.
      body: days ? { reason, days } : { reason },
    });
  }

  unblock(id: string) {
    return this.request<AdminUser>(`${this.baseUrl}/${id}/unblock`, { method: "POST" });
  }

  /**
   * Akkauntni o'chirish. Ruxsat `users.delete`.
   *
   * QATOR BAZADAN O'CHMAYDI: backend `status = 'deleted'` qo'yadi va
   * mezbon rejimini so'ndiradi. Ledger yozuvlari foydalanuvchiga
   * havola qiladi va hech qachon o'chirilmaydi, ya'ni qatorni
   * o'chirish butun hisob tarixini buzardi.
   *
   * Blokdan farqi: blokdan qaytish bor, bundan yo'q — `unblock`
   * o'chirilgan akkauntni ataylab tiklamaydi.
   */
  remove(id: string) {
    return this.request<AdminUser>(`${this.baseUrl}/${id}`, { method: "DELETE" });
  }

  /**
   * Faollik tarixi: odam O'ZI qilgan amallar va unga qilingan amallar
   * birga. Faqat birinchisini ko'rsatish "nega bloklangan?" degan
   * savolni javobsiz qoldirardi.
   *
   * Ruxsat `users.activity.read`.
   */
  activity(id: string, query: PaginationQuery = {}) {
    return this.request<Paginated<AdminActivity>>(`${this.baseUrl}/${id}/activity`, {
      query: { ...query },
    });
  }

  /** Faol qurilmalar. Ruxsat `users.devices.read`. */
  sessions(id: string) {
    return this.request<UserSession[]>(`${this.baseUrl}/${id}/sessions`);
  }

  /**
   * Qurilmani chiqarish. Ruxsat `users.sessions.revoke` — ko'rish
   * huquqidan ALOHIDA: ro'yxatni ko'rish tekshiruv, chiqarish esa
   * boshqa darajadagi aralashuv.
   */
  revokeSession(id: string, sessionId: string) {
    return this.request<void>(`${this.baseUrl}/${id}/sessions/${sessionId}`, {
      method: "DELETE",
    });
  }

  // Rol biriktirish bu yerda EMAS: u `accessApi.setUserRoles` da, chunki
  // rollar auth modulining ma'lumoti va bitta forma butun ro'yxatni
  // almashtiradi (ADR 0009).
}

export const adminUsersApi = new AdminUsersApi();
